import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AjaxData, AjaxService } from './ajax.service';
import { ApiRoutesV1 } from '../common/routes';
import { clone } from 'lodash';

export interface Usages {
  dailyUsage: number;
  monthlyUsage: number;
  monthlyLimit: number;
}

@Injectable()
export class SmsUsagesService {
  private readonly usage$$ = new BehaviorSubject<Usages>({
    dailyUsage: 0,
    monthlyUsage: 0,
    monthlyLimit: 0,
  });

  constructor(private readonly ajaxService: AjaxService) {
    this.ajaxService
      .get(ApiRoutesV1.reviewSmsUsage)
      .pipe(
        map((response: HttpResponse<AjaxData>) => {
          return {
            dailyUsage: response.body.data.daily.usage,
            monthlyUsage: response.body.data.monthly.usage,
            monthlyLimit: response.body.data.monthly.limit,
          };
        }),
      )
      .subscribe((usages) => this.usage$$.next(usages));
  }

  public getSmsUsages(): Observable<Usages> {
    return this.usage$$.asObservable();
  }

  public get hasSmsEnabled$(): Observable<boolean> {
    return this.usage$$.pipe(map((usages) => usages.monthlyLimit > 0));
  }

  public increaseUsageBy(nbSmsSent: number): void {
    const newUsage: Usages = clone(this.usage$$.getValue());
    newUsage.dailyUsage += nbSmsSent;
    newUsage.monthlyUsage += nbSmsSent;
    this.usage$$.next(newUsage);
  }
}
